// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

import { EEnvironmentName } from "../app/shared/enums/eEnvironmentName";
import { baseEnvironment } from "./baseEnvironment";


export const environment = {
  // Declaration & Init Var envirronement for Api DEV-MonBienNeuf -----------------------------------------------------------------------------------------------------------
  environmentName: EEnvironmentName.DEV,
  production: false,
  urlServer: 'https://dev-myfactory-espacenotaire-api-hmdmcjddhbfsb9f7.francecentral-01.azurewebsites.net/api/',
  // urlServer: 'https://localhost:7116/',
  authorizedFileTypes : ['jpg', 'jpeg', 'png', 'xlsx', 'xls', 'docx', 'pdf', 'webp'],
  fileStoragePath : 'Resources/visuels/customer_account/',
  numVersionTxt: baseEnvironment.version,
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
